import { render, staticRenderFns } from "./csv-upload.vue?vue&type=template&id=272ebba4&scoped=true&"
import script from "./csv-upload.vue?vue&type=script&lang=js&"
export * from "./csv-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ebba4",
  null
  
)

export default component.exports